import { render } from "./B2bPageMailServer.vue?vue&type=template&id=1048b42e&scoped=true&lang=pug"
import script from "./B2bPageMailServer.vue?vue&type=script&lang=js"
export * from "./B2bPageMailServer.vue?vue&type=script&lang=js"

import "./B2bPageMailServer.vue?vue&type=style&index=0&id=1048b42e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1048b42e"]])

export default __exports__